import styles from './downloadPaymentOrderPDFModal.module.css'
import { useEffect, useState } from "react"
import { PaymentOrder } from '../../../state/types'
import { fileHelpers, usePDFActions } from '../../../../../features/files'
import { FileTile, FileType, Modal, ModalId } from '../../../../../features/ui'
import { PaymentOrderPDF } from '../payment-order-pdf/paymentOrderPDF'

type Props = {
    paymentOrder?: PaymentOrder
}

export const DownloadPaymentOrderPDFModal = (props: Props) => {
    const { paymentOrder } = props

    const [pdfName, setPdfName] = useState<string>()

    const { paymentOrderFileName } = fileHelpers

    const { generatePDF, printPDF, isPrinting } = usePDFActions()

    useEffect(() => {
        paymentOrder && setPdfName(paymentOrderFileName(paymentOrder.code))
    }, [paymentOrder])

    const pdfId = 'payment-order-pdf'

    const onSubmit = () => {
        pdfName && generatePDF(pdfId, pdfName)
    }

    const renderHiddenPDF = () => paymentOrder ? (
        <div className={styles.hidden}>
            <PaymentOrderPDF
                id={pdfId}
                paymentOrder={paymentOrder}
            />
        </div>
    ) : <></>

    return (
        <Modal
            modalId={ModalId.DOWNLOAD_PAYMENT_ORDER_PDF}
            title="Descargar Orden"
            submitLabel="Descargar"
            submitIcon="download"
            onSubmit={onSubmit}
            secondaryLabel="Imprimir"
            secondaryIcon="printer"
            disableSecondary={isPrinting || !pdfName}
            onSecondarySubmit={() => printPDF(pdfId)}
        >
            <FileTile fileType={FileType.PDF} fileName={pdfName}/>
            {renderHiddenPDF()}
        </Modal>
    )
}
